module.exports = __webpack_public_path__ + "static/img/weather_028.5dccbd2a.svg";